module.exports = __webpack_public_path__ + "img/reference60.676ecf0d.jpg";